import { jsx as _jsx } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { getSubmitButtonOptions } from '@rjsf/utils';
/** The `SubmitButton` renders a button that represent the `Submit` action on a form
 */
export default function SubmitButton(_ref) {
  let {
    uiSchema
  } = _ref;
  const {
    submitText,
    norender,
    props: submitButtonProps = {}
  } = getSubmitButtonOptions(uiSchema);
  if (norender) {
    return null;
  }
  return _jsx(Box, {
    marginTop: 3,
    children: _jsx(Button, {
      type: 'submit',
      variant: 'contained',
      color: 'primary',
      ...submitButtonProps,
      children: submitText
    })
  });
}